module.exports = __webpack_public_path__ + "img/afterBtn@2x.58dee009.png";